define("SuiteDB.SDBServiceHardwareItems.Image.View", [
  "suitedb_sdbservicehardwareitems_image_modal.tpl",
  "Backbone",
], function (sdbservicehardwareitems_image_modal_tpl, Backbone) {
  "use strict";

  return Backbone.View.extend({
    template: sdbservicehardwareitems_image_modal_tpl,

    initialize: function initialize(options) {
      var self = this;
      this.image = options.image;
      this.page_header = options.pageHeader;
    },
    getContext: function getContext() {
      return {
        image: this.image,
      };
    },
  });
});
